var _defs, _line, _g, _line2, _line3, _line4, _line5, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2834.65 2834.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-2 {\n        stroke-width: 40px;\n      }\n\n      .cls-2, .cls-3, .cls-4 {\n        fill: none;\n      }\n\n      .cls-2, .cls-4 {\n        stroke: #58595b;\n      }\n\n      .cls-5 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-4 {\n        stroke-width: 60px;\n      }\n\n      .cls-6 {\n        fill: #58595b;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 2834.65,
    height: 2834.65
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 2834.65,
    height: 2834.65
  })))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1417.8,
    y1: 2056.84,
    x2: 1417.8,
    y2: 2527.81
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 50.14,
    y1: 1889.23,
    x2: 416.56,
    y2: 1522.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 2784.5,
    y1: 1889.23,
    x2: 2418.09,
    y2: 1522.82
  }))), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 858.32,
    y1: 2433.06,
    x2: 1064.92,
    y2: 1977.17
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1977.26,
    y1: 2433.06,
    x2: 1770.65,
    y2: 1977.17
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 428.76,
    y1: 2206.45,
    x2: 738.38,
    y2: 1794.66
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 2406.81,
    y1: 2206.45,
    x2: 2097.2,
    y2: 1794.66
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1417.79,2093.34c643.39,0,1164.96-671.01,1164.96-671.01,0,0-521.57-671.01-1164.96-671.01S252.83,1422.33,252.83,1422.33c0,0,521.57,671.01,1164.96,671.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1417.79,2093.34c643.39,0,1164.96-671.01,1164.96-671.01,0,0-521.57-671.01-1164.96-671.01S252.83,1422.33,252.83,1422.33c0,0,521.57,671.01,1164.96,671.01Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClose);
export default __webpack_public_path__ + "static/media/eye_close.1ca4850a3ba325b6a13b77d9b74072c7.svg";
export { ForwardRef as ReactComponent };